import React, { useContext } from 'react';
import cx from 'classnames';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { type HeroAnimationState } from 'Utilities/animation';
import { VehicleLookupState } from 'Utilities/vehicles/@types';

import { ComponentContent, CONTENT_SIZES, ContentSize } from 'Layout';

import VrmInputMileage from './VrmInputMileage';
import VrmInputVRM from './VrmInputVRM';

import styles from './VrmInput.scss';

type VrmInputProps = {
  analyticsEvents?: {
    onButtonClick?: (vrm: string) => void;
    onInputFocus?: () => void;
    onLandingPageInputFocus?: () => void;
  };
  inProgress?: boolean;
  loadingHandler?: (val: HeroAnimationState) => void;
  maxWidth?: ContentSize;
  setShowMileage?: (value: boolean) => void;
  showMileage?: boolean;
  vehicle?: VehicleLookupState | null;
};

const VrmInput = ({
  analyticsEvents,
  inProgress,
  loadingHandler,
  maxWidth = CONTENT_SIZES.narrow,
  setShowMileage,
  showMileage = false,
  vehicle: vehicleProp = null,
}: VrmInputProps) => {
  const { vehicleLookupState: lookupVehicle } = useContext(VehicleLookupContext);
  const vehicle = vehicleProp || lookupVehicle;

  const InputMode = (showMileage)
    ? VrmInputMileage
    : VrmInputVRM;

  const input = (
    <InputMode
      vrm={vehicle?.vrm || vehicle?.resultError?.vrm}
      {...{
        analyticsEvents,
        loadingHandler,
        setShowMileage,
        showMileage,
      }}
    />
  );

  return (
    <ComponentContent
      className={cx(styles.container, {
        [styles.fadeOut]: !!inProgress,
      })}
      maxWidth={maxWidth}
    >
      { input }
    </ComponentContent>
  );
};

export default VrmInput;
